var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.996 0A5.995 5.995 0 0 0 0 5.996a5.995 5.995 0 0 0 5.996 5.997 5.995 5.995 0 0 0 5.997-5.997A5.995 5.995 0 0 0 5.996 0Zm2.781 7.278L6.53 9.527a.747.747 0 0 1-.533.217.747.747 0 0 1-.532-.217L3.216 7.278A.752.752 0 0 1 4.28 6.214l.967.967V2.998c0-.412.337-.75.75-.75.412 0 .749.338.749.75v4.19l.967-.967a.752.752 0 0 1 1.282.532c0 .203-.083.39-.218.525Z"
  })));
};
export default SvgDownload;